import { Form, useFormikContext } from "formik";
import { ComponentProps, FC, FormEvent } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { FormError, ICompanyFormState } from "../../shared/types";

export const DrawerForm = styled(Form)`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	height: 100%;
`;

export type SubmitAction = "save" | "next";

export interface CreateCompanyStepForm<T> {
	initialValues: T;
	onSubmit: (values: T) => void | Promise<void>;
}

export const DrawerFormWithSubmitter: FC<ComponentProps<"form">> = ({ onSubmit, ...props }) => {
	const formik = useFormikContext();
	const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
		const submitter = (e.nativeEvent as SubmitEvent).submitter;
		if (submitter && submitter instanceof HTMLButtonElement && submitter.name && submitter.value) {
			void formik.setFieldValue(submitter.name, submitter.value, false);
		}
		onSubmit?.(e as any);
		formik.handleSubmit(e);
	};

	return <DrawerForm {...props} onSubmit={handleSubmit} />;
};

export const FormActions = styled.div`
	justify-content: end;
	display: flex;
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const useCompanyFormValidation = () => {
	const { t } = useTranslation();

	return (values: ICompanyFormState) => {
		const errors: FormError = {};

		if (!values.name) {
			errors.name = t("Required field");
		}

		if (!values.tenants?.length) {
			errors.tenants = t("Required field");
		}

		const tenantIds = Object.keys(values.pivotValues).filter(
			(tenantId) => values.pivotValues[tenantId as any].carFleetStatus === null,
		);

		if (tenantIds.length) {
			errors.pivotValues = {};
			tenantIds.forEach((tenantId) => (errors.pivotValues[tenantId] = { carFleetStatus: t("Required field") }));
		}

		return errors;
	};
};
